import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";

import {
  IoMdArrowDropdown,
  IoMdArrowDropup,
  IoMdArrowDropleft,
  IoMdArrowDropright
} from "react-icons/io";

import ColorSchema from "../Color/index.tsx";
import "./customTooltip.scss";
import { CloseIcon } from "../Icons.tsx";
// tooltip
function CustomTooltip({
  title,
  placement,
  color,
  children,
  className,
  style
}) {
  const renderTooltip = props => (
    <Tooltip id="button-tooltip" {...props}>
      <div className="position-relative">
        <p
          style={{
            backgroundColor: ColorSchema[`${color}`],
            // position: "relative",
            padding: "5px 10px",
            borderRadius: 8,
            margin: 0
          }}
        >
          {title}
        </p>
        {placement == "top" && (
          <div
            style={{
              position: "absolute",
              bottom: "-16px",
              right: "35%",
              color: ColorSchema[`${color}`]
            }}
          >
            <IoMdArrowDropdown className="fs-3" />
          </div>
        )}
        {placement == "bottom" && (
          <div
            style={{
              position: "absolute",
              top: "-17px",
              right: "35%",
              color: ColorSchema[`${color}`]
            }}
          >
            <IoMdArrowDropup className="fs-3" />
          </div>
        )}
        {placement == "right" && (
          <div
            style={{
              position: "absolute",
              bottom: "12%",
              left: "-16px",
              color: ColorSchema[`${color}`]
            }}
          >
            <IoMdArrowDropleft className="fs-3" />
          </div>
        )}
        {placement == "left" && (
          <div
            style={{
              position: "absolute",
              bottom: "12%",
              right: "-16px",
              color: ColorSchema[`${color}`]
            }}
          >
            <IoMdArrowDropright IoMdArrowDropleft className="fs-3" />
          </div>
        )}
      </div>
    </Tooltip>
  );
  return (
    <OverlayTrigger
      style={{ backgroundColor: ColorSchema[`${color}`], ...style }}
      placement={placement}
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
      className={className}
      // show={true}
    >
      {children}
    </OverlayTrigger>
  );
}

// popover
function CustomPopover({
  children,
  show,
  setShow,
  placement,
  popoverColor,
  popoverTitle,
  popoverBody
}) {
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header
        className="d-flex justify-content-between align-items-center"
        style={{ backgroundColor: popoverColor }}
      >
        <h5>{popoverTitle}</h5>
        <button
          className="btn px-0"
          onClick={() => {
            setShow(false);
          }}
        >
          <CloseIcon />
        </button>
      </Popover.Header>
      <Popover.Body>{popoverBody}</Popover.Body>
    </Popover>
  );
  return (
    <div>
      <OverlayTrigger
        trigger="click"
        placement={placement}
        overlay={popover}
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        {children}
      </OverlayTrigger>
    </div>
  );
}
export { CustomTooltip, CustomPopover };
